export default function auth(to, from, next) {
  if (localStorage.getItem("auth")) {
    next();
  } else {
    window.localStorage.setItem("open", true);
    next("/");
  }
}
